export default __webpack_public_path__ + "static/media/Transportation_Card.e3566851.svg";